import { Component, OnInit } from '@angular/core';
import { navItems } from './sidebar-data';
import { NavService } from '../../../services/nav.service';
import { NavItem } from './nav-item/nav-item';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  navItems: NavItem[] = [];

  constructor(public navService: NavService) {}

  ngOnInit(): void {
    const userTeam = this.getUserTeam();
    const userVisibility = this.getUserVisibility();
    this.navItems = navItems.filter(item => {
      if (item.requiredTeam) {
        return userVisibility === 'global' || userTeam === item.requiredTeam;
      }
      if (item.requiredTeams) {
        return userVisibility === 'global' || item.requiredTeams.includes(userTeam);
      }
      if (item.requiredVisibility === 'internal') {
        return userVisibility !== 'vendor' && userVisibility !== 'customer';
      }
      return true;
    });
  }

  private getUserTeam(): string {
    try {
      const userInfoString = localStorage.getItem('userInfo');
      if (!userInfoString) return '';
      const userInfo = JSON.parse(userInfoString);
      const team = userInfo['custom:team'] || userInfo.team || '';
      return (team || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  private getUserVisibility(): string {
    try {
      const userInfoString = localStorage.getItem('userInfo');
      if (!userInfoString) return '';
      const userInfo = JSON.parse(userInfoString);
      return (userInfo['custom:visibility'] || userInfo.visibility || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }
}
